import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  CircularProgress,
  TextField,
  Typography,
} from '@mui/material';
import { marketingPersonApi } from '../../../modules/services/marketingPersonService';
import translate from '../../../i18n/translate';

interface SelectMarketingPersonModalProps {
  open: boolean;
  onClose: () => void;
  onSelect: (personId: number, personName: string, personPhone: string) => void;
  currentPersonName?: string;
}

const SelectMarketingPersonModal: React.FC<SelectMarketingPersonModalProps> = ({ open, onClose, onSelect, currentPersonName }) => {
  const [search, setSearch] = useState('');

  const { data: personsList = [], isLoading } = marketingPersonApi.useGetMarketingPersonsListQuery(
    { search: search || undefined, status: 'active' },
    { skip: !open }
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{translate('marketingPersonsSelectPerson')}</DialogTitle>
      <DialogContent>
        {currentPersonName && (
          <Typography variant="body2" color="textSecondary" mb={1}>
            Current: <b>{currentPersonName}</b>
          </Typography>
        )}
        <TextField
          label={translate('marketingPersonsSearch')}
          size="small"
          fullWidth
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ mb: 2 }}
        />
        {isLoading ? (
          <CircularProgress color="warning" />
        ) : (
          <List sx={{ maxHeight: 300, overflow: 'auto' }}>
            {personsList.map((person) => (
              <ListItem key={person.id} disablePadding>
                <ListItemButton onClick={() => onSelect(person.id, person.name, person.phone)}>
                  <ListItemText
                    primary={person.name}
                    secondary={person.phone}
                  />
                </ListItemButton>
              </ListItem>
            ))}
            {personsList.length === 0 && (
              <Typography color="textSecondary" textAlign="center">No persons found</Typography>
            )}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{translate('marketingPersonsCancel')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SelectMarketingPersonModal;
